import {__} from '@wordpress/i18n';
import {registerPaymentMethod} from '@woocommerce/blocks-registry';
import apiFetch from '@wordpress/api-fetch';
import {decodeEntities} from '@wordpress/html-entities';
import {getSetting} from '@woocommerce/settings';
import {addQueryArgs} from '@wordpress/url'
import parse from 'html-react-parser';
import {useSelect, dispatch, useDispatch} from "@wordpress/data";
import {registerPlugin} from '@wordpress/plugins';
import {registerCheckoutFilters} from '@woocommerce/blocks-checkout';

const settings = getSetting('yith_funds_data', {});
const defaultLabel = __(
    'YITH Funds',
    'yith-woocommerce-account-funds'
);

const label = decodeEntities(settings.title) || defaultLabel;
/**
 * Content component
 */
const Content = () => {

    return decodeEntities(parse(settings.description) || '');
};
/**
 * Label component
 *
 * @param {*} props Props from payment API.
 */
const Label = (props) => {
    const {PaymentMethodLabel} = props.components;
    return <PaymentMethodLabel text={label}/>;
};

/**
 * Funds payment method config object.
 */
const YITH_Funds = {
    name: "yith_funds",
    label: <Label/>,
    content: <Content/>,
    edit: <Content/>,
    canMakePayment: () => true,
    ariaLabel: label,
    supports: {
        features: settings.supports,
    },
};
registerPaymentMethod(YITH_Funds);


if (typeof yith_gateway_funds_args !== 'undefined' && yith_gateway_funds_args?.coupon_code) {
    const render = () => {
        const couponCode = yith_gateway_funds_args.coupon_code;
        const selectedPaymentMethod = useSelect((select) => select('wc/store/payment').getActivePaymentMethod());
        const appliedCoupons = useSelect((select) => select('wc/store/cart').getCartData().coupons);
        const hasCoupon = appliedCoupons.filter(coupon => coupon.code === couponCode);

        const {createNotice} = useDispatch('core/notices');

        if ('yith_funds' === selectedPaymentMethod && hasCoupon.length === 0) {
            apiFetch({
                path: addQueryArgs('/wc/store/v1/cart/apply-coupon', {
                    code: couponCode,
                    context: 'yith_apply_fund_coupon'
                }),
                method: 'POST',
                cache: 'no-store',
            }).then((result) => {
                dispatch('wc/store/cart').receiveCart(result);
                createNotice(
                    'info',
                    yith_gateway_funds_args.coupon_note,
                    {
                        id: 'coupon-form',
                        type: 'snackbar',
                        context: 'wc/checkout',
                    }
                );
            }).catch((error) => {
                dispatch('wc/store/cart').receiveError(error);
            }).finally(() => {
                dispatch('wc/store/cart').receiveApplyingCoupon('');
            })
        } else if ('yith_funds' !== selectedPaymentMethod && hasCoupon.length > 0) {
            apiFetch({
                path: addQueryArgs('/wc/store/v1/cart/remove-coupon', {
                    code: couponCode,
                    context: 'yith_apply_fund_coupon'
                }),
                method: 'POST',
                cache: 'no-store',
            }).then((result) => {
                dispatch('wc/store/cart').receiveCart(result);
            }).catch((error) => {
                dispatch('wc/store/cart').receiveError(error);
            })
        }
    }
    registerPlugin('yith-funds-discount', {
        render,
        scope: 'woocommerce-checkout',
    });

    const filterCoupons = (coupons) => {
        return coupons.map((coupon) => {
            // Regex to match autocoupon then unlimited undersores and numbers
            if (coupon.label.match(/yith_funds_coupon(?:_\d+)+/)) {
                return {
                    ...coupon,
                    label: yith_gateway_funds_args.coupon_label,
                };
            }

            if( coupon.label === yith_gateway_funds_args.deposit_coupon_code ){
                return {
                    ...coupon,
                    label: yith_gateway_funds_args.deposit_coupon_label,
                };
            }

            return coupon;

        });
    };

    registerCheckoutFilters('yith-funds-rename-funds-coupon', {
        coupons: filterCoupons,
    });
}

const discountMessage = document.querySelector('.ywf-discount-message-wrapper.wc-cart-block'),
    cartItemsBlock = document.querySelector('.wp-block-woocommerce-cart-line-items-block'),
    cartParent = cartItemsBlock?.parentNode;
if (discountMessage) {
    if (cartParent) {
        cartParent.insertBefore(discountMessage, cartItemsBlock);
        discountMessage.classList.add('show');
    }

    if (document.querySelector('.wp-block-woocommerce-checkout')) {
        discountMessage.classList.add('show');
    }
}